module.exports = __webpack_public_path__ + "resources/img/img_prodiscovery4_m_en.6f026f74313c3a744e2a1ed6bc122481.png";